export default "__VITE_ASSET__DKFLxKGA__"